import "./not-found.component.scss";
import LOGO_MAIN from "../../assets/images/AIDA-logo.svg";
import NOT_FOUND_IMAGE from "../../assets/images/404.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
const NotFoundComponent = () => {
    const navigate = useNavigate();


    const clickBack = () => {

        navigate("/");
    }

    return (
            <>
            <div className="not-found-control">

                <img className="not-found-logo-left" src={LOGO_MAIN}></img>
                <div className="not-found-main-item">
                    <img src={NOT_FOUND_IMAGE} className="not-found-main-img"></img>
                    <span className="not-found-main-title">ไม่พบหน้าที่คุณค้นหา</span>
                    <span className="not-found-main-desc">กรุณาลองใหม่อีกครั้ง หรือ กลับสู่หน้าหลัก</span>
                    <Button className="not-found-button" onClick={clickBack}>กลับสู่หน้าหลัก</Button>
                </div>
            </div>
              
            </>
    )
}

export default NotFoundComponent;